import config from '~/config';

function getLocalisedMobileErrorMessage() {
	if (config.supportedCountries.includes('NZ')) {
		return 'Please enter a valid mobile phone number';
	}

	return 'Please enter a valid Australian phone number';
}

function getLocalisedPostcodeMessage() {
	if (config.supportedCountries.includes('NZ')) {
		return 'Please enter a valid postcode';
	}

	return 'Please enter a valid Australian postcode';
}

export const ERROR_MESSAGES = {
	first_name: {
		REQUIRED: 'Please enter your first name',
	},
	last_name: {
		REQUIRED: 'Please enter your last name',
	},
	terms: { REQUIRED: 'Please read and agree to the terms and conditions' },
	privacy: { REQUIRED: 'Please read and agree to the privacy policy' },
	mobile: {
		REQUIRED: 'Please enter your mobile phone number',
		INVALID_FORMAT: getLocalisedMobileErrorMessage(),
	},
	confirm_mobile: {
		REQUIRED: 'Please confirm your phone number',
		INVALID_FORMAT: 'Please ensure your phone number matches',
	},
	email: {
		REQUIRED: 'Please enter your email address',
		INVALID_FORMAT: 'Please enter a valid email address',
	},
	confirm_email: {
		REQUIRED: 'Please confirm your email address',
		INVALID_FORMAT: 'Please ensure your email address matches',
	},
	receipt_upload: {
		REQUIRED: 'Please upload your proof of purchase',
		INVALID_FORMAT: 'Please upload a valid receipt',
	},
	suburb: {
		REQUIRED: 'Please enter your suburb',
	},
	state: {
		REQUIRED: 'Please enter your state',
	},
	address_line_1: {
		REQUIRED: 'Please enter your address',
	},
	postcode: {
		REQUIRED: 'Please enter your postcode',
		INVALID_FORMAT: getLocalisedPostcodeMessage(),
	},
	aus_postcode: {
		REQUIRED: 'Please enter your postcode',
		INVALID_FORMAT: getLocalisedPostcodeMessage(),
	},
	date_of_birth: {
		REQUIRED: 'Please enter your date of birth',
		INVALID_FORMAT: 'Please enter a valid date of birth',
		INVALID_AGE: (minimumAge: number) => `You must be at least ${minimumAge} to enter`,
	},
};

export const REGEX = {
	GLOBAL_POSTCODE: /\d{4}/,
	AUS_POSTCODE:
		/^(0[289][0-9]{2})|([1345689][0-9]{3})|(2[0-8][0-9]{2})|(290[0-9])|(291[0-4])|(7[0-4][0-9]{2})|(7[8-9][0-9]{2})$/,
	MOBILE_PHONE: /^((0|\+61)(4))([ -])?\d{2}([ -])?\d{2}([ -])?\d([ -])?\d{3}$/,
	AU_MOBILE_PHONE: /^((0|\+61)(4))([ -])?\d{2}([ -])?\d{2}([ -])?\d([ -])?\d{3}$/,
	NZ_MOBILE_PHONE: /^(\+64|0)[2-9]\d{7,9}$/,
	GLOBAL_MOBILE: /^\+?\d{9,11}$/,
};
